import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DatenerhebungPage from './pages/DatenerhebungPage';
import DashboardV2Page from './pages/DashboardV2Page';
import NotFoundPage from './pages/NotFoundPage';
import MailingListPage from './pages/MailingListPage';
import SignIn from './components/auth/SignIn';
import reportWebVitals from './reportWebVitals';
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";
import { startSdxThemeOverride } from "./utils/sdxThemeOverride";

Amplify.configure(awsconfig);
startSdxThemeOverride();

const pathname = window.location.pathname.toLowerCase();
const isDatenerhebung = pathname === '/datenerhebung';
const isDashboardV2 = pathname === '/dashboard';
const isMailingList = pathname === '/mailinglist';
const isRegistration = pathname === '/registrieren' || pathname === '/registrieren/';
const isLandingPage = pathname === '/' || pathname === '/index.html';
const isNotFound = !isDatenerhebung && !isDashboardV2 && !isMailingList && !isLandingPage && !isRegistration;

function ProtectedDatenerhebung() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'auth' | 'guest'

  useEffect(() => {
    getCurrentUser()
      .then(() => setStatus('auth'))
      .catch(() => setStatus('guest'));
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <sdx-loading-spinner></sdx-loading-spinner>
      </div>
    );
  }

  if (status === 'guest') {
    return (
      <SignIn
        onSuccess={() => setStatus('auth')}
        onRegister={() => { window.location.href = '/'; }}
      />
    );
  }

  return <DatenerhebungPage />;
}

function ProtectedDashboardV2() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'auth' | 'guest'
  const [user, setUser] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const currentUser = await getCurrentUser();
        const attributes = await fetchUserAttributes();
        setUser({ ...currentUser, attributes });
        setStatus('auth');
      } catch {
        setStatus('guest');
      }
    })();
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <sdx-loading-spinner></sdx-loading-spinner>
      </div>
    );
  }

  if (status === 'guest') {
    return (
      <SignIn
        onSuccess={async () => {
          const attributes = await fetchUserAttributes();
          const currentUser = await getCurrentUser();
          setUser({ ...currentUser, attributes });
          setStatus('auth');
        }}
        onRegister={() => { window.location.href = '/'; }}
      />
    );
  }

  return <DashboardV2Page user={user} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isDatenerhebung ? <ProtectedDatenerhebung /> : isDashboardV2 ? <ProtectedDashboardV2 /> : isMailingList ? <MailingListPage /> : isNotFound ? <NotFoundPage /> : <App initialShowRegister={isRegistration} />}
  </React.StrictMode>
);

reportWebVitals();
